(() => {
  const root = window.Shopify?.routes?.root || '/';
  const refreshCart = () => {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  };

  const updateWarranty = async (toggle) => {
    const offer = toggle.closest('[data-mc-warranty-offer]');
    if (!offer || offer.classList.contains('is--loading')) return;

    const shouldAdd = toggle.checked;
    const previousState = !shouldAdd;
    const variantId = offer.dataset.mcWarrantyVariant;
    offer.classList.add('is--loading');

    try {
      if (shouldAdd) {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
        if (!response.ok) throw new Error(`Warranty add failed with ${response.status}`);
        const data = await response.json();
        if (data.status) throw new Error(data.description || 'Warranty add failed');
      } else {
        const cartResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
        if (!cartResponse.ok) throw new Error(`Cart read failed with ${cartResponse.status}`);
        const cart = await cartResponse.json();
        const updates = {};
        cart.items.forEach((item) => {
          if (item.product_type === 'warranty_item') updates[item.key] = 0;
        });
        if (Object.keys(updates).length > 0) {
          const response = await fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates }),
          });
          if (!response.ok) throw new Error(`Warranty removal failed with ${response.status}`);
        }
      }
      refreshCart();
    } catch (error) {
      toggle.checked = previousState;
      console.error('Cart warranty update failed:', error);
    } finally {
      offer.classList.remove('is--loading');
    }
  };

  let warrantyReconcileInFlight = false;
  let previousMerchandiseKeys = null;
  const removeWarrantyAfterMerchandiseRemoval = async () => {
    if (warrantyReconcileInFlight) return;
    warrantyReconcileInFlight = true;

    try {
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Cart read failed with ${response.status}`);
      const cart = await response.json();
      const warrantyItems = cart.items.filter((item) => item.product_type === 'warranty_item');
      const merchandiseItems = cart.items.filter((item) => item.product_type !== 'warranty_item');
      const currentMerchandiseKeys = new Set(merchandiseItems.map((item) => item.key));
      const merchandiseWasRemoved =
        previousMerchandiseKeys !== null &&
        [...previousMerchandiseKeys].some((key) => !currentMerchandiseKeys.has(key));
      previousMerchandiseKeys = currentMerchandiseKeys;

      if (!merchandiseWasRemoved || warrantyItems.length === 0) return;

      const updates = {};
      warrantyItems.forEach((item) => {
        updates[item.key] = 0;
      });
      const updateResponse = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!updateResponse.ok)
        throw new Error(`Orphaned warranty removal failed with ${updateResponse.status}`);
      refreshCart();
    } catch (error) {
      console.error('Orphaned warranty cleanup failed:', error);
    } finally {
      warrantyReconcileInFlight = false;
    }
  };

  document.addEventListener('change', (event) => {
    const toggle = event.target.closest?.('[data-mc-warranty-toggle]');
    if (toggle) updateWarranty(toggle);
  });
  document.addEventListener('cart:updated', removeWarrantyAfterMerchandiseRemoval);
})();
